import { render, staticRenderFns } from "./AccommodationsInput.vue?vue&type=template&id=710d5ab9&scoped=true"
import script from "./AccommodationsInput.vue?vue&type=script&lang=js"
export * from "./AccommodationsInput.vue?vue&type=script&lang=js"
import style0 from "./AccommodationsInput.vue?vue&type=style&index=0&id=710d5ab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d5ab9",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QIcon});
